import { reportClient } from '../../api/clients';
import fetchInventory from './fetch-inventory/fetch-inventory';

const inventoryService = {
  fetchInventory: fetchInventory(reportClient),
};

export default inventoryService;
